export function noOp() {}

export function identity<T>(x: T): T {
  return x;
}
